<div class="analytic-settings" data-automation-id="analytic-settings-container">
    <div class="header-bar" data-automation-id="analytic-settings-header">
        <button type="button" data-automation-id="analytic-settings-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="isSaveDisabled()" *ngIf="hasPermissions">Save</button>
        <button type="button" data-automation-id="analytic-settings-discard-changes-button" class="secondary-button"
            (click)="discardChanges()" [disabled]="isDiscardDisabled()" *ngIf="hasPermissions">Discard Changes</button>
        <button type="button" class="help-button" data-automation-id="analytic-settings-help-button"
            (click)="openHelp()"><i class="fa fa-question"></i></button>
    </div>
    <form class="content" #contentForm="ngForm" data-automation-id="analytic-settings-content" [resBusySpinner]="isBusy"
        [message]="isBusyMessage">
        <div class="left-settings-panel">
            <div class="settings-panel-header">Deduplication</div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label [ngClass]="{'disabled': !hasPermissions}">Deduplication Scope:</label>
                </div>
                <div class="modal-row-column-auto radio-column">
                    <res-custom-radio-button [automationId]="'analytic-settings-dedupe-scope-global'"
                        [isDisabled]="!hasPermissions" [(ngModel)]="viewModel.model.deDupScope" content="Global"
                        name="deDupScope" value="HORIZONTAL" (ngModelChange)="onChange()"></res-custom-radio-button>
                    <res-custom-radio-button [automationId]="'analytic-settings-dedupe-scope-custodial'"
                        [isDisabled]="!hasPermissions" [(ngModel)]="viewModel.model.deDupScope" content="Custodial"
                        name="deDupScope" value="VERTICAL" (ngModelChange)="onChange()"></res-custom-radio-button>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label [ngClass]="{'disabled': !hasPermissions}">Email Deduplication Scope:</label>
                </div>
                <div class="modal-row-column-auto radio-column">
                    <res-custom-radio-button [automationId]="'analytic-settings-email-dedupe-scope-file'"
                        [isDisabled]="!hasPermissions" [(ngModel)]="viewModel.model.deDupStrategy"
                        content="File Duplicates Only (File MD5)" name="deDupStrategy" value="FILE_DUPLICATION"
                        (ngModelChange)="onChange()">
                    </res-custom-radio-button>
                    <res-custom-radio-button [automationId]="'analytic-settings-email-dedupe-scope-message'"
                        [isDisabled]="!hasPermissions" [(ngModel)]="viewModel.model.deDupStrategy"
                        content="Message Content and Attributes" name="deDupStrategy" value="MSG_CONTENT"
                        (ngModelChange)="onChange()">
                    </res-custom-radio-button>
                    <div class="radio-checkbox-column">
                        <res-custom-checkbox name="senderIncluded" automationId="analytic-settings-email-dedupe-sender"
                            [(ngModel)]="viewModel.model.senderIncluded" content="From"
                            [disabled]="viewModel.model.deDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="additionalSenderIncluded"
                            automationId="analytic-settings-email-dedupe-additional-sender"
                            [(ngModel)]="viewModel.model.additionalSenderIncluded" content="Sender"
                            [disabled]="viewModel.model.deDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="recipientIncluded"
                            automationId="analytic-settings-email-dedupe-recipients"
                            [(ngModel)]="viewModel.model.recipientIncluded" content="Recipients"
                            [disabled]="viewModel.model.deDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="bccIncluded" automationId="analytic-settings-email-dedupe-bcc"
                            [(ngModel)]="viewModel.model.bccIncluded" content="Bcc"
                            [disabled]="viewModel.model.deDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="attachmentIncluded"
                            automationId="analytic-settings-email-dedupe-attachments"
                            [(ngModel)]="viewModel.model.attachmentIncluded" content="Attachments"
                            [disabled]="viewModel.model.deDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="sentDateIncluded"
                            automationId="analytic-settings-email-dedupe-date-sent"
                            [(ngModel)]="viewModel.model.sentDateIncluded" content="Date Sent"
                            [disabled]="viewModel.model.deDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="messageIdIncluded"
                            automationId="analytic-settings-email-dedupe-messageid"
                            [(ngModel)]="viewModel.model.messageIdIncluded" content="MessageID"
                            [disabled]="viewModel.model.deDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                    </div>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label [ngClass]="{'disabled': !hasPermissions}">Calendar Deduplication Scope:</label>
                </div>
                <div class="modal-row-column-auto radio-column">
                    <res-custom-radio-button [automationId]="'analytic-settings-calender-dedupe-scope-file'"
                        [isDisabled]="!hasPermissions" [(ngModel)]="viewModel.model.calendarDeDupStrategy"
                        content="File Duplicates Only (File MD5)" name="calendarDeDupStrategy" value="FILE_DUPLICATION"
                        (ngModelChange)="onChange()"></res-custom-radio-button>
                    <res-custom-radio-button [automationId]="'analytic-settings-calender-dedupe-scope-message'"
                        [isDisabled]="!hasPermissions" [(ngModel)]="viewModel.model.calendarDeDupStrategy"
                        content="Message Content and Attributes" name="calendarDeDupStrategy" value="MSG_CONTENT"
                        (ngModelChange)="onChange()">
                    </res-custom-radio-button>
                    <div class="radio-checkbox-column">
                        <res-custom-checkbox name="calendarSenderIncluded"
                            automationId="analytic-settings-calender-dedupe-sender"
                            [(ngModel)]="viewModel.model.calendarSenderIncluded" content="From"
                            [disabled]="viewModel.model.calendarDeDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="additionalCalendarSenderIncluded"
                            automationId="analytic-settings-calender-dedupe-additional-sender"
                            [(ngModel)]="viewModel.model.additionalCalendarSenderIncluded" content="Sender"
                            [disabled]="viewModel.model.calendarDeDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="calendarRecipientIncluded"
                            automationId="analytic-settings-calender-dedupe-recipients"
                            [(ngModel)]="viewModel.model.calendarRecipientIncluded" content="Recipients"
                            [disabled]="viewModel.model.calendarDeDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="calendarAttachmentIncluded"
                            automationId="analytic-settings-calender-dedupe-attachments"
                            [(ngModel)]="viewModel.model.calendarAttachmentIncluded" content="Attachments"
                            [disabled]="viewModel.model.calendarDeDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                        <res-custom-checkbox name="calendarDateIncluded"
                            automationId="analytic-settings-calender-dedupe-date-started-ended"
                            [(ngModel)]="viewModel.model.calendarDateIncluded" content="Date Started / Ended"
                            [disabled]="viewModel.model.calendarDeDupStrategy != 'MSG_CONTENT' || !hasPermissions"
                            (ngModelChange)="onChange()">
                        </res-custom-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-settings-panel">
            <div class="settings-panel-header">Email Threading</div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox name="autoThreading" automationId="analytic-settings-automatic-email-threading"
                        [isDisabled]="!hasPermissions" [(ngModel)]="viewModel.model.autoThreading"
                        content="Enable Automatic Threading of Emails and Short Messages" (ngModelChange)="onChange()">
                    </res-custom-checkbox>
                </div>
            </div>
            <div class="modal-row">
                <div class="threads-column">
                    <div class="modal-row-column-auto">
                        <label [ngClass]="{'disabled': !hasPermissions}">Email Threading Modes:</label>
                    </div>
                    <div class="modal-row-column-auto">
                        <div>
                            <res-custom-checkbox name="RFC_2822_METADATA" [isDisabled]="!hasPermissions"
                                automationId="'analytic-settings-threading-rfc-metadata'"
                                [(ngModel)]="emailThreadingModes.RFC_2822_METADATA" content="RFC 2822 Metadata"
                                (ngModelChange)="onChange()">
                            </res-custom-checkbox>
                            <res-custom-checkbox name="MS_OTLOOK_METADATA" [isDisabled]="!hasPermissions"
                                automationId="'analytic-settings-threading-outlook-metadata'"
                                [(ngModel)]="emailThreadingModes.MS_OTLOOK_METADATA" content="MS Outlook Metadata"
                                (ngModelChange)="onChange()">
                            </res-custom-checkbox>
                            <res-custom-checkbox name="CONTENT_BASED" [isDisabled]="!hasPermissions"
                                automationId="'analytic-settings-threading-content-based'"
                                [(ngModel)]="emailThreadingModes.CONTENT_BASED" content="Content-Based"
                                (ngModelChange)="onChange()">
                            </res-custom-checkbox>
                        </div>
                    </div>
                </div>
                <div class="threads-column">
                    <div class="modal-row-column-auto no-label-fix-width">
                        <label [ngClass]="{'disabled': !hasPermissions}">Short Message Threading Mode:</label>
                    </div>
                    <div class="modal-row-column-auto">
                        <div>
                            <res-custom-checkbox name="SMF_CHAT_ID_BASED" [isDisabled]="!hasPermissions"
                                automationId="'analytic-settings-threading-smf-chat-id'"
                                [(ngModel)]="emailThreadingModes.SMF_CHAT_ID_BASED" content="SMF Chat Id"
                                (ngModelChange)="onChange()">
                            </res-custom-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label [ngClass]="{'disabled': !hasPermissions}">Inclusive Email Scope:</label>
                </div>
                <div class="modal-row-column-auto radio-column">
                    <res-custom-radio-button [automationId]="'analytic-settings-inclusive-message-only'"
                        [isDisabled]="!hasPermissions" [(ngModel)]="viewModel.model.messageAndAttachmentsScope"
                        content="Message Only" name="messageAndAttachmentsScope" [value]="false"
                        (ngModelChange)="onChange()">
                    </res-custom-radio-button>
                    <res-custom-radio-button [automationId]="'analytic-settings-inclusive-message-and-attachments'"
                        [isDisabled]="!hasPermissions" [(ngModel)]="viewModel.model.messageAndAttachmentsScope"
                        content="Message and Attachments" name="messageAndAttachmentsScope" [value]="true"
                        (ngModelChange)="onChange()">
                    </res-custom-radio-button>
                </div>
            </div>
            <div class="settings-panel-header top-border">Exclusion Searches</div>
            <div class="key-value-list-container"
                [attr.data-automation-id]="'analytic-settings-exclusion-searches-container'">
                <res-key-value-list [placeholderField1]='"Search Name ..."' [isDisabled]="!hasPermissions"
                    [attr.data-automation-id]="'analytic-settings-exclusion-searches-key-value-list'"
                    [placeholderField2]='"Search Query ..."' [rows]="viewModel.model.caseDiscardCandidatesNamedQueries"
                    automationId="analytic-settings-exclusion-searches-" [excludeTrashBtnFromTabIndex]="true"
                    [validateName]="true" [maxNameLength]="100" [maxQueryLength]="1024"
                    [isQueryValidationContext]="true" [settingsType]="settingsType">
                </res-key-value-list>
            </div>
        </div>
    </form>
</div>